export default __webpack_public_path__ + "static/media/BMWGroupSerif-Bold.96161635.woff2";